module.exports = __webpack_public_path__ + "static/media/Bacteria.0105a363.gif";